export class TipoVisitaModel {
  constructor({ id, nome, descricao, acessivelClientes = false }) {
    (this.id = id),
      (this.nome = nome),
      (this.descricao = descricao),
      (this.acessivelClientes = acessivelClientes);
  }
}
